"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Camera` instead */
export const Camera = createSVGIcon(
  <g clipPath="url(#clip0_6491_975)" stroke="currentColor">
    <path
      d="M23.143 8.571a1.715 1.715 0 0 0-1.714-1.714H18L15.429 3.43H8.57L6 6.857H2.571A1.714 1.714 0 0 0 .857 8.571v10.286a1.714 1.714 0 0 0 1.714 1.714H21.43a1.715 1.715 0 0 0 1.714-1.714z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 16.714A3.857 3.857 0 1 0 12 9a3.857 3.857 0 0 0 0 7.714Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </g>,
  "Camera",
  { color: Core.icon.default, fill: "none", viewBox: "0 0 24 24" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
